import { useDeveloperModeStore } from '@/stores/developerMode'

export function isDeveloperModeEnabled(): boolean {
  return useDeveloperModeStore().isEnabled
}

export function isDeveloperOnlyRoute(route: { meta?: Record<string, any>; matched?: Array<{ meta?: Record<string, any> }> }): boolean {
  if (route.meta?.developerOnly) return true
  return Boolean(route.matched?.some(record => record.meta?.developerOnly))
}
